import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { ModalService } from 'app/shared/services/modal/modal.service';
import { ContentImageCropperComponent } from 'app/shared/components/content-image-cropper/content-image-cropper.component';
import { ImageService } from '../../services/image/image.service';
import { Subscription } from 'rxjs/Subscription';
import { LoaderButton } from '../loader-button/loader-button.component';
import { ImageLibraryComponent } from '../image-library/image-library.component';
import { WalkthroughService } from 'app/shared/services/walkthrough/walkthrough.service';

@Component({
  selector: 'tog-image-library-cropper-modal',
  templateUrl: './image-library-cropper-modal.component.html',
  styleUrls: ['./image-library-cropper-modal.component.scss']
})
export class ImageLibraryCropperModalComponent implements OnInit, OnDestroy {
  libraryHidden: boolean = false;
  libraryExpanded: boolean = false;
  imageServiceSubscription: Subscription;
  modalSubscription: Subscription;
  saveButtonActive: boolean = false;
  buttonText: string = 'Add';

  walkthroughVisible: boolean = false;
  walkthroughSubscription: Subscription;

  @Input() autoHide: boolean = true;
  @Input() rounded: boolean = false;
  @Input() editMode: boolean = false;
  @Output() imageChanged: EventEmitter<any> = new EventEmitter();

  @ViewChild('cropper') cropper: ContentImageCropperComponent;
  @ViewChild('library') library: ImageLibraryComponent;
  @ViewChild('saveImageButton') saveImageButton: LoaderButton;

  constructor(public modal: ModalService, public imageService: ImageService, public walkthroughService: WalkthroughService) { }

  ngOnInit() {
    // Listen for the first image selection. Once an image has been selected the save button can be active.
    this.imageServiceSubscription = this.imageService.imageSelected.subscribe(() => {
      this.saveButtonActive = true;
      if (this.imageServiceSubscription) this.imageServiceSubscription.unsubscribe();
    });
    this.walkthroughSubscription = this.walkthroughService.walkthroughs['imageLibrary'].nextStep.subscribe((id) => {
      if (id != -1) this.walkthroughVisible = true;
      else this.walkthroughVisible = false;
    });
    this.modalSubscription = this.modal.modalShown.subscribe((id) => {
      let self = this;
      if (id == 'image-library-cropper') {
        setTimeout(() => {
          self.walkthroughService.initializeWalkthrough('imageLibrary');
        }, 500);
      }
    });
  }

  imageSelected(imageUrl: string) { }

  show() {
    this.saveImageButton.setInactive();
    this.buttonText = this.editMode ? 'Save' : 'Add';
    this.libraryHidden = this.libraryExpanded = false;
    this.modal.show('image-library-cropper');
  }

  hide() {
    this.modal.hide();
  }

  updateImage() {
    this.cropper.save();
    this.imageChanged.emit();
    if (this.autoHide) this.modal.hide(300);
    this.saveImageButton.setConfirmed();
  }

  toggleLibraryHidden() {
    this.libraryHidden = !this.libraryHidden;
    // this.libraryExpanded = false;
  }

  ngOnDestroy() {
    if (this.imageServiceSubscription) this.imageServiceSubscription.unsubscribe();
    if (this.modalSubscription) this.modalSubscription.unsubscribe();
    if (this.walkthroughSubscription) this.walkthroughSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/image-library-cropper-modal/image-library-cropper-modal.component.ts